export default class WindowVisibility {
  public windowId: string = "";
  public isVisibile: boolean = true;

  constructor(windowId: string, isVisibile: boolean) {
    this.windowId = windowId;
    this.isVisibile = isVisibile;
  }
}
